module.exports = __webpack_public_path__ + "img/4.32f5e010.png";